import { z } from "zod";
/**
 * Money is stored everywhere as an integer number of **minor units** (e.g.
 * paisa for PKR, cents for USD) to avoid floating-point rounding errors in the
 * ledger. Amounts fit comfortably within Number.MAX_SAFE_INTEGER for personal
 * finance, so we use `number` rather than bigint at the API boundary.
 */
export const DEFAULT_CURRENCY = "PKR";
/** Common currencies offered in the account/currency dropdowns. */
export const CURRENCIES = [
    "PKR", "PLN", "USD", "EUR", "GBP", "AED", "SAR", "INR", "CAD", "AUD", "TRY",
];
/** ISO-4217-ish currency code (3 uppercase letters). */
export const currencySchema = z
    .string()
    .trim()
    .toUpperCase()
    .length(3)
    .regex(/^[A-Z]{3}$/, "currency must be a 3-letter ISO code");
/** A positive integer amount in minor units, capped to a safe range. */
export const amountMinorSchema = z
    .number()
    .int("amount must be an integer in minor units")
    .positive("amount must be greater than zero")
    .max(Number.MAX_SAFE_INTEGER);
/** A signed integer amount in minor units (for ledger entries / balances). */
export const signedAmountMinorSchema = z
    .number()
    .int()
    .min(-Number.MAX_SAFE_INTEGER)
    .max(Number.MAX_SAFE_INTEGER);
/** Convert a major-unit decimal (e.g. 12.34) to minor units (1234). */
export function toMinorUnits(major, fractionDigits = 2) {
    return Math.round(major * 10 ** fractionDigits);
}
/** Convert minor units (1234) to a major-unit decimal (12.34). */
export function toMajorUnits(minor, fractionDigits = 2) {
    return minor / 10 ** fractionDigits;
}
/** Format minor units as a localized currency string. */
export function formatMoney(minor, currency = DEFAULT_CURRENCY, locale = "en-PK") {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
    }).format(toMajorUnits(minor));
}
//# sourceMappingURL=money.js.map